import axios from 'axios';

interface SendDataParams {
  data: Uint8Array;
  partitionKey: string;
  streamArn: string;
}

const KINESIS_ENDPOINT = '/api/kinesis';

/**
 * Sends the provided data to the Kinesis stream.
 */
export const sendData = async ({
  data,
  partitionKey,
  streamArn,
}: SendDataParams): Promise<void> => {
  try {
    const response = await axios.post(KINESIS_ENDPOINT, {
      data: Array.from(data),
      partitionKey,
      streamArn,
    });

    if (response.status !== 200) {
      throw new Error(response.data.error || 'Failed to send data to Kinesis');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error(
        'Error sending data:',
        error.response?.data || error.message
      );
    } else {
      console.error('Error sending data:', error);
    }
    throw error;
  }
};
